<template>
  <v-app>
    <v-main style="background: #fff8fc">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
  created() {
    /*esto se hace para buscar la suscripción en el local storage y luego guardarla en el state
    en caso que la persona no pague la suscripcion
    */
    let subscription_storage = localStorage.getItem('subscription_selected')
    if (subscription_storage) {
      this.$store.dispatch('setNewSubscription', JSON.parse(subscription_storage))
    }

    let campaign_order = localStorage.getItem('campaign_order')
    if (campaign_order) {
      this.$store.dispatch('setPackageOrder', JSON.parse(campaign_order))
    }
  }
};
</script>

<style>

.v-snack:not(.v-snack--absolute) {
  z-index: 1031 !important
}

@font-face {
  font-family: 'Backwards Light';
  src: url(./assets/fonts/TTBackwardsLight.otf);
}

@font-face {
  font-family: 'Baloo Regular';
  src: url(./assets/fonts/BalooRegular.ttf);
}

@font-face {
  font-family: 'Baloo Medium';
  src: url(./assets/fonts/BalooMedium.ttf);
}
html {
	overflow-x: hidden;
}
body {
	overflow-x: hidden;
	overflow: hidden;
	margin: 0 0 0 0;
	padding: 0px;
}
.material-icons-outlined {
  color: #0D3B60 !important
}
.content {
  width: 85%;
  margin: auto;
}
.description {
  font-family: 'Baloo Regular';
  color: #0D3B60;
  font-size: 18px;
  text-align: justify;
  text-justify: auto;
}

.swal2-container {
  z-index: 10000 !important
}

.swal2-popup {
  font-family: var(--font-baloo-regular) !important;
  border-radius: 0 !important;
  background: var(--color-light) !important;
}

.swal2-title, .swal2-content {
  color: var(--color-tertiary) !important;
}

.v-dialog__content {
  z-index: 2000 !important
}

.swal2-styled.swal2-confirm {
  background-color: var(--color-primary) !important;
  border-radius: 0 !important;
  padding: 5px 40px 5px 40px !important
}

@media screen and (min-width: 2501px) and (max-width: 5060px) {
  .container-text-init {
    font-size: 2em !important
  }
  .navbar {
    width: 90% !important;
  }
  .logo {
    width: 40% !important
  }
  .items-menu {
    width: 80% !important;
    padding: 1em !important;
  }
  .items-menu, .material-icons-outlined {
    font-size: 40px !important
  }
  .flavors {
    padding: 3em !important;
  }
  .frutas {
    width: 50% !important;
    height: 400px !important;
  }
  .helados {
    width: 50% !important;
    height: 450px !important;
  }
  .hojas {
    width: 55% !important;
    height: 400px !important;
  }
  .title-landing {
    font-size: 3em !important
  }
  .description {
    font-size: 2em
  }
  .title-with-image h2 {
    font-size: 3em !important
  }
  .img-categoria-sabor1 {
    width: 100px !important;
    height: 100px !important
  }
  .img-categoria-sabor2 {
    width: 150px !important;
    height: 150px !important
  }
  .img-sabor {
    width: 80px !important;
    height: 80px !important;
  }
  .title-detail {
    font-size: 5em !important;
  }
  .img-flavor-detail {
    width: 25% !important;
  }
  .title-nutrition, .description-detail {
    font-size: 1.8em !important;
  }
}

@media only screen and (min-width: 1720px) and (max-width: 2500px) {
  .container-text-init {
    font-size: 1.3em !important
  }
  .navbar {
    width: 90% !important
  }
  .logo {
    width: 30% !important
  }
  .items-menu {
    width: 30% !important;
    padding: 1em !important;
  }
  .items-menu, .material-icons-outlined {
    font-size: 25px !important
  }
  .flavors {
    padding: 3em !important;
  }
  .frutas {
    width: 60% !important;
    height: 300px !important;
  }
  .helados {
    width: 60% !important;
    height: 320px !important;
  }
  .hojas {
    width: 60% !important;
    height: 300px !important;
  }
  .title-landing {
    font-size: 2em !important
  }
  .description {
    font-size: 1.2em !important
  }
  .title-with-image h2 {
    font-size: 1.8em !important
  }
  .img-categoria-sabor1 {
    width: 50px !important;
    height: 60px !important
  }
  .img-categoria-sabor2 {
    width: 100px !important;
    height: 70px !important
  }
  .img-sabor {
    width: 60px !important;
    height: 60px !important;
  }
  .title-detail {
    font-size: 2.2em !important;
  }
  .img-flavor-detail {
    width: 25% !important;
  }
  .title-nutrition, .description-detail {
    font-size: 1.2em !important;
  }
}

@media (max-width: 1440px) {
  .logo {
    width: 140px !important;
  }
  .frutas {
    width: 55% !important;
    height: 220px !important;
  }
  .helados {
    width: 55% !important;
    height: 220px !important;
  }
  .hojas {
    width: 55% !important;
    height: 200px !important;
  }
}

@media (max-width: 1024px) {
  .flavors {
    width: 95% !important;
  }
  .title-with-image h2 {
    font-size: 20px !important;
    font-weight: 500
  }
  .frutas {
    height: 190px !important;
    max-height: 200px !important
  }
  .helados {
    height: 200px !important;
    width: 55% !important
  }
  .hojas {
    height: 180px !important;
    max-height: 200px !important
  }
  .title-landing {
    font-size: 35px !important;
    margin-bottom: 30px !important;
  }
  .description {
    font-size: 17px !important
  }
  .logo {
    width: 140px !important
  }
}

@media (max-width: 768px) {
  .flavors {
    width: 95% !important;
    padding: 10px !important;
  }
  .content-flavor {
    width: 90% !important;
    margin: auto
  }
  .frutas {
    width: 60% !important;
    height: 150px !important;
    max-height: 150px !important
  }
  .helados {
    width: 60% !important;
    height: 170px !important;
  }
  .hojas {
    width: 75% !important;
    height: 150px !important;
    max-height: 150px !important
  }
  .title-landing {
    font-size: 27px !important;
  }
  .description {
    font-size: 15px !important
  }
  .img-flavor-detail {
    height: 120px !important;
    max-height: 120px !important;
    margin-bottom: 30px !important
  }
  .title-detail {
    font-size: 35px !important;
  }
  .title-nutrition {
    font-size: 12px !important;
  }
  .description-detail {
    font-size: 12px !important;
  }
}

@media only screen and (min-width: 426px) and (max-width: 767px){
  .frutas {
    width: 50% !important
  }
  .helados {
    width: 50% !important
  }
  .hojas {
    width: 50% !important
  }
  .content-flavor {
    width: 65% !important;
  }
  .title-landing {
    font-size: 30px !important;
    text-align: center !important;
  }
  .description {
    font-size: 18px !important
  }
  .title-with-image h2 {
    font-size: 25px !important
  }
}

@media (max-width: 425px) {
  .logo {
    width: 90px !important;
    height: 120px
  }
  .flavors {
    width: 90% !important;
    padding: 0 20px 20px 20px !important;
    margin-top: 0px !important;
  }
  .content-flavor {
    width: 90% !important;
    margin: auto
  }
  .title-landing {
    text-align: center;
  }
  .content {
    margin: 0 !important;
    width: 100% !important;
    text-align: center !important;
  }
  .title-detail {
    text-align: center;
  }
  .img-flavor-detail {
    width: 140px !important;
  }
  .frutas {
    width: 55% !important;
    height: 140px !important;
  }
  .helados {
    width: 55% !important;
    height: 140px !important;
  }
  .hojas {
    width: 60% !important;
    height: 120px !important;
    max-height: 120px !important
  }
}

@media (max-width: 400px) {
  .logo {
    width: 90px !important;
    height: 120px
  }
  .frutas {
    height: 120px !important;
    max-height: 120px !important
  }
  .content-flavor {
    width: 90% !important;
  }
  .helados {
    height: 120px !important;
    max-height: 120px !important
  }
  .hojas {
    height: 120px !important;
    max-height: 120px !important
  }
  .img-flavor-detail {
    width: 130px !important;
    text-align: center !important
  }
  .title-nutrition {
    font-size: 11px !important
  }
  .value-nutrition {
    font-size: 11px !important
  }
}

@media (max-width: 320px) {
  .img-flavor-detail {
    width: 130px !important;
  }
  .logo {
    width: 80px !important;
    height: 100px
  }
  .content-flavor {
    width: 90% !important;
  }
  .helados {
    width: 65% !important;
  }
  .frutas {
    width: 65% !important;
  }
  .hojas {
    width: 70% !important;
  }
}
</style>
